import React from 'react';

import { Layout } from 'components';

export default function DefaultHeader() {
  return (
    <Layout.Header className="border-0">
      <Layout.Nav className="ml-auto">
        <Layout.Nav.User>
          <Layout.Nav.User.ChangePasswordOption />
        </Layout.Nav.User>
      </Layout.Nav>
    </Layout.Header>
  );
}
